import React, { useState, useEffect } from 'react'
import { path } from 'ramda'
import { Loader } from '../../components'
import { fetchFromBilling } from './billingAccess'
import { usePaymentPolling } from './usePaymentPolling'
import bindDeviceActions from '../device/redux/bindDeviceActions'
import './StayOnPlanButton.less'

function StayOnPlanButton ({ sub, user, macAddress, actions }) {
  const [isUpdating, setIsUpdating] = useState(false)

  const { startPolling, stopPolling } = usePaymentPolling(actions, () => {
    setIsUpdating(false)
  })

  // Watch for downgrade cancellation and stop polling early
  useEffect(() => {
    if (!isUpdating) return

    if (sub.willDowngradeTo === null || sub.willDowngradeTo === undefined) {
      stopPolling()
      setIsUpdating(false)
    }
  }, [sub.willDowngradeTo, isUpdating, stopPolling])

  const handleClick = async () => {
    setIsUpdating(true)

    try {
      const userId = path(['info', '_id'], user)
      await fetchFromBilling(
        `/subscriptions?userId=${userId}&macAddress=${macAddress}&productName=${sub.productName}`,
        {
          method: 'PUT',
          body: JSON.stringify({
            new_product_name: sub.productName
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      startPolling()
    } catch (error) {
      console.error('Error canceling downgrade:', error)
      setIsUpdating(false)
      stopPolling()
    }
  }

  if (isUpdating) {
    return <Loader />
  }

  return (
    <button className='btn-stay-on-plan' onClick={handleClick}>
      <i className='icon-feature-hub'></i>
      Stay on Plan
    </button>
  )
}

StayOnPlanButton.displayName = 'StayOnPlanButton'

export default bindDeviceActions(StayOnPlanButton)
